export default __webpack_public_path__ + "static/media/PerComponentForSharing.6205b697.pdf";